import React from 'react';
import './TimePortal.css';

const TimePortal = ({ scrollProgress }) => {
  return (
    <div className="time-portal" style={{ '--scroll': scrollProgress }}>
      {/* Central Vortex */}
      <div className="vortex-container">
        <div className="vortex-ring ring-1"></div>
        <div className="vortex-ring ring-2"></div>
        <div className="vortex-ring ring-3"></div>
        <div className="vortex-ring ring-4"></div>
        <div className="vortex-core"></div>
      </div>

      {/* Time Particles */}
      <div className="particles">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              '--delay': `${Math.random() * 10}s`,
              '--duration': `${10 + Math.random() * 20}s`,
              '--x': `${Math.random() * 100}%`,
              '--size': `${2 + Math.random() * 4}px`,
              '--hue': `${120 + Math.random() * 60}`
            }}
          />
        ))}
      </div>

      {/* Time Grid */}
      <div className="time-grid">
        <div className="grid-horizontal"></div>
        <div className="grid-vertical"></div>
      </div>

      {/* Scan Lines */}
      <div className="scan-lines">
        <div className="scan-line"></div>
        <div className="scan-line delay"></div>
      </div>

      {/* Ambient Glow */}
      <div className="ambient-glow glow-1"></div>
      <div className="ambient-glow glow-2"></div>
      <div className="ambient-glow glow-3"></div>
    </div>
  );
};

export default TimePortal;
